import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";
import { usePublic } from "hooks/usePublic";

const PublicRouter: React.FC<{}> = () => {
  const { user, procesando } = usePublic();

  if (procesando) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!user) {
    return <Navigate to="/404" replace />;
  }
  return <Outlet />;
};

export default PublicRouter;
